export let countryList = [
    {
        "en_name": "Afghanistan",
        "cn_name": "阿富汗",
        "two_letter_code": "AF",
        "three_letter_code": "AFG",
        "number_code": 4,
        "lng": 67.709953,
        "lat": 33.93911
    },
    {
        "en_name": "Albania",
        "cn_name": "阿尔巴尼亚",
        "two_letter_code": "AL",
        "three_letter_code": "ALB",
        "number_code": 8,
        "lng": 20.168331,
        "lat": 41.153332
    },
    {
        "en_name": "Algeria",
        "cn_name": "阿尔及利亚",
        "two_letter_code": "DZ",
        "three_letter_code": "DZA",
        "number_code": 12,
        "lng": 1.659626,
        "lat": 28.033886
    },
    {
        "en_name": "Andorra",
        "cn_name": "安道尔",
        "two_letter_code": "AD",
        "three_letter_code": "AND",
        "number_code": 20,
        "lng": 1.60155,
        "lat": 42.5462
    },
    {
        "en_name": "Angola",
        "cn_name": "安哥拉",
        "two_letter_code": "AO",
        "three_letter_code": "AGO",
        "number_code": 24,
        "lng": 17.873887,
        "lat": -11.202692
    },
    {
        "en_name": "Anguilla",
        "cn_name": "安圭拉",
        "two_letter_code": "AI",
        "three_letter_code": "AIA",
        "number_code": 660,
        "lng": -63.0686,
        "lat": 18.2206
    },
    {
        "en_name": "Argentina",
        "cn_name": "阿根廷",
        "two_letter_code": "AR",
        "three_letter_code": "ARG",
        "number_code": 32,
        "lng": -63.6166719999999,
        "lat": -38.416097
    },
    {
        "en_name": "Armenia",
        "cn_name": "亚美尼亚",
        "two_letter_code": "AM",
        "three_letter_code": "ARM",
        "number_code": 51,
        "lng": 45.038189,
        "lat": 40.069099
    },
    {
        "en_name": "Ascension",
        "cn_name": "阿森松岛",
        "two_letter_code": "AC",
        "three_letter_code": "ASC",
        "number_code": "",
        "lng": -90.94,
        "lat": 30.2
    },
    {
        "en_name": "Australia",
        "cn_name": "澳大利亚",
        "two_letter_code": "AU",
        "three_letter_code": "AUS",
        "number_code": 36,
        "lng": 133.775136,
        "lat": -25.274398
    },
    {
        "en_name": "Austria",
        "cn_name": "奥地利",
        "two_letter_code": "AT",
        "three_letter_code": "AUT",
        "number_code": 40,
        "lng": 14.550072,
        "lat": 47.516231
    },
    {
        "en_name": "Azerbaijan",
        "cn_name": "阿塞拜疆",
        "two_letter_code": "AZ",
        "three_letter_code": "AZE",
        "number_code": 31,
        "lng": 47.576927,
        "lat": 40.143105
    },
    {
        "en_name": "Bahrain",
        "cn_name": "巴林",
        "two_letter_code": "BH",
        "three_letter_code": "BHR",
        "number_code": 48,
        "lng": 50.6378,
        "lat": 25.9304
    },
    {
        "en_name": "Bangladesh",
        "cn_name": "孟加拉国",
        "two_letter_code": "BD",
        "three_letter_code": "BGD",
        "number_code": 50,
        "lng": 90.356331,
        "lat": 23.684994
    },
    {
        "en_name": "Barbados",
        "cn_name": "巴巴多斯",
        "two_letter_code": "BB",
        "three_letter_code": "BRB",
        "number_code": 52,
        "lng": -59.5432,
        "lat": 13.1939
    },
    {
        "en_name": "Belarus",
        "cn_name": "白俄罗斯",
        "two_letter_code": "BY",
        "three_letter_code": "BLR",
        "number_code": 112,
        "lng": 27.953389,
        "lat": 53.709807
    },
    {
        "en_name": "Belgium",
        "cn_name": "比利时",
        "two_letter_code": "BE",
        "three_letter_code": "BEL",
        "number_code": 56,
        "lng": 4.469936,
        "lat": 50.503887
    },
    {
        "en_name": "Belize",
        "cn_name": "伯利兹",
        "two_letter_code": "BZ",
        "three_letter_code": "BLZ",
        "number_code": 84,
        "lng": -88.49765,
        "lat": 17.189877
    },
    {
        "en_name": "Benin",
        "cn_name": "贝宁",
        "two_letter_code": "BJ",
        "three_letter_code": "BEN",
        "number_code": 204,
        "lng": 2.315834,
        "lat": 9.30769
    },
    {
        "en_name": "Bermuda",
        "cn_name": "百慕大",
        "two_letter_code": "BM",
        "three_letter_code": "BMU",
        "number_code": 60,
        "lng": -64.7505,
        "lat": 32.3078
    },
    {
        "en_name": "Bhutan",
        "cn_name": "不丹",
        "two_letter_code": "BT",
        "three_letter_code": "BTN",
        "number_code": 64,
        "lng": 90.433601,
        "lat": 27.514162
    },
    {
        "en_name": "Bolivia",
        "cn_name": "玻利维亚",
        "two_letter_code": "BO",
        "three_letter_code": "BOL",
        "number_code": 68,
        "lng": -63.5886529999999,
        "lat": -16.290154
    },
    {
        "en_name": "Bosnia and Herzegovina",
        "cn_name": "波黑",
        "two_letter_code": "BA",
        "three_letter_code": "BIH",
        "number_code": 70,
        "lng": 17.679076,
        "lat": 43.915886
    },
    {
        "en_name": "Botswana",
        "cn_name": "博茨瓦纳",
        "two_letter_code": "BW",
        "three_letter_code": "BWA",
        "number_code": 72,
        "lng": 24.684866,
        "lat": -22.328474
    },
    {
        "en_name": "Brazil",
        "cn_name": "巴西",
        "two_letter_code": "BR",
        "three_letter_code": "BRA",
        "number_code": 76,
        "lng": -51.92528,
        "lat": -14.235004
    },
    {
        "en_name": "Brunei",
        "cn_name": "文莱",
        "two_letter_code": "BN",
        "three_letter_code": "BRN",
        "number_code": 96,
        "lng": 114.727669,
        "lat": 4.535277
    },
    {
        "en_name": "Bulgaria",
        "cn_name": "保加利亚",
        "two_letter_code": "BG",
        "three_letter_code": "BGR",
        "number_code": 100,
        "lng": 25.48583,
        "lat": 42.733883
    },
    {
        "en_name": "Burkina Faso",
        "cn_name": "布基纳法索",
        "two_letter_code": "BF",
        "three_letter_code": "BFA",
        "number_code": 854,
        "lng": -1.561593,
        "lat": 12.238333
    },
    {
        "en_name": "Burundi",
        "cn_name": "布隆迪",
        "two_letter_code": "BI",
        "three_letter_code": "BDI",
        "number_code": 108,
        "lng": 29.918886,
        "lat": -3.373056
    },
    {
        "en_name": "Cambodia",
        "cn_name": "柬埔寨",
        "two_letter_code": "KH",
        "three_letter_code": "KHM",
        "number_code": 116,
        "lng": 104.990963,
        "lat": 12.565679
    },
    {
        "en_name": "Cameroon",
        "cn_name": "喀麦隆",
        "two_letter_code": "CM",
        "three_letter_code": "CMR",
        "number_code": 120,
        "lng": 12.354722,
        "lat": 7.369722
    },
    {
        "en_name": "Canada",
        "cn_name": "加拿大",
        "two_letter_code": "CA",
        "three_letter_code": "CAN",
        "number_code": 124,
        "lng": -106.346771,
        "lat": 56.130366
    },
    {
        "en_name": "Cayman Islands (the)",
        "cn_name": "开曼群岛",
        "two_letter_code": "KY",
        "three_letter_code": "CYM",
        "number_code": 136,
        "lng": -80.567,
        "lat": 19.5135
    },
    {
        "en_name": "Central African Republic (the)",
        "cn_name": "中非",
        "two_letter_code": "CF",
        "three_letter_code": "CAF",
        "number_code": 140,
        "lng": 20.939444,
        "lat": 6.611111
    },
    {
        "en_name": "Chad",
        "cn_name": "乍得",
        "two_letter_code": "TD",
        "three_letter_code": "TCD",
        "number_code": 148,
        "lng": 18.732207,
        "lat": 15.454166
    },
    {
        "en_name": "Chile",
        "cn_name": "智利",
        "two_letter_code": "CL",
        "three_letter_code": "CHL",
        "number_code": 152,
        "lng": -71.542969,
        "lat": -35.675147
    },
    {
        "en_name": "China",
        "cn_name": "中国",
        "two_letter_code": "CN",
        "three_letter_code": "CHN",
        "number_code": 156,
        "lng": 104.195397,
        "lat": 35.86166
    },
    {
        "en_name": "Colombia",
        "cn_name": "哥伦比亚",
        "two_letter_code": "CO",
        "three_letter_code": "COL",
        "number_code": 170,
        "lng": -74.297333,
        "lat": 4.570868
    },
    {
        "en_name": "Cook Islands (the)",
        "cn_name": "库克群岛",
        "two_letter_code": "CK",
        "three_letter_code": "COK",
        "number_code": 184,
        "lng": -159.778,
        "lat": -21.2367
    },
    {
        "en_name": "Costa Rica",
        "cn_name": "哥斯达黎加",
        "two_letter_code": "CR",
        "three_letter_code": "CRI",
        "number_code": 188,
        "lng": -83.753428,
        "lat": 9.748917
    },
    {
        "en_name": "Croatia",
        "cn_name": "克罗地亚",
        "two_letter_code": "HR",
        "three_letter_code": "HRV",
        "number_code": 191,
        "lng": 15.2,
        "lat": 45.1
    },
    {
        "en_name": "Cuba",
        "cn_name": "古巴",
        "two_letter_code": "CU",
        "three_letter_code": "CUB",
        "number_code": 192,
        "lng": -77.781167,
        "lat": 21.521757
    },
    {
        "en_name": "Czech Republic (the)",
        "cn_name": "捷克",
        "two_letter_code": "CZ",
        "three_letter_code": "CZE",
        "number_code": 203,
        "lng": 15.472962,
        "lat": 49.817492
    },
    {
        "en_name": "Congo (the Democratic Republic of the)",
        "cn_name": "刚果（金）",
        "two_letter_code": "CD",
        "three_letter_code": "COD",
        "number_code": 180,
        "lng": 21.758664,
        "lat": -4.038333
    },
    {
        "en_name": "Denmark",
        "cn_name": "丹麦",
        "two_letter_code": "DK",
        "three_letter_code": "DNK",
        "number_code": 208,
        "lng": 9.501785,
        "lat": 56.26392
    },
    {
        "en_name": "Djibouti",
        "cn_name": "吉布提",
        "two_letter_code": "DJ",
        "three_letter_code": "DJI",
        "number_code": 262,
        "lng": 42.590275,
        "lat": 11.825138
    },
    {
        "en_name": "Dominica",
        "cn_name": "多米尼克",
        "two_letter_code": "DM",
        "three_letter_code": "DMA",
        "number_code": 212,
        "lng": -61.371,
        "lat": 15.415
    },
    {
        "en_name": "Dominican Republic (the)",
        "cn_name": "多米尼加",
        "two_letter_code": "DO",
        "three_letter_code": "DOM",
        "number_code": 214,
        "lng": -70.162651,
        "lat": 18.735693
    },
    {
        "en_name": "Timor-Leste",
        "cn_name": "东帝汶",
        "two_letter_code": "TL",
        "three_letter_code": "TLS",
        "number_code": 626,
        "lng": 125.727539,
        "lat": -8.874217
    },
    {
        "en_name": "Ecuador",
        "cn_name": "厄瓜多尔",
        "two_letter_code": "EC",
        "three_letter_code": "ECU",
        "number_code": 218,
        "lng": -78.1834059999999,
        "lat": -1.831239
    },
    {
        "en_name": "Egypt",
        "cn_name": "埃及",
        "two_letter_code": "EG",
        "three_letter_code": "EGY",
        "number_code": 818,
        "lng": 30.802498,
        "lat": 26.820553
    },
    {
        "en_name": "El Salvador",
        "cn_name": "萨尔瓦多",
        "two_letter_code": "SV",
        "three_letter_code": "SLV",
        "number_code": 222,
        "lng": -88.89653,
        "lat": 13.794185
    },
    {
        "en_name": "Equatorial Guinea",
        "cn_name": "赤道几内亚",
        "two_letter_code": "GQ",
        "three_letter_code": "GNQ",
        "number_code": 226,
        "lng": 10.267895,
        "lat": 1.650801
    },
    {
        "en_name": "Eritrea",
        "cn_name": "厄立特里亚",
        "two_letter_code": "ER",
        "three_letter_code": "ERI",
        "number_code": 232,
        "lng": 39.782334,
        "lat": 15.179384
    },
    {
        "en_name": "Estonia",
        "cn_name": "爱沙尼亚",
        "two_letter_code": "EE",
        "three_letter_code": "EST",
        "number_code": 233,
        "lng": 25.013607,
        "lat": 58.595272
    },
    {
        "en_name": "Ethiopia",
        "cn_name": "埃塞俄比亚",
        "two_letter_code": "ET",
        "three_letter_code": "ETH",
        "number_code": 231,
        "lng": 40.489673,
        "lat": 9.145
    },
    {
        "en_name": "Falkland Islands (the) [Malvinas]",
        "cn_name": "福克兰群岛（马尔维纳斯）",
        "two_letter_code": "FK",
        "three_letter_code": "FLK",
        "number_code": 238,
        "lng": -59.523613,
        "lat": -51.796253
    },
    {
        "en_name": "Fiji",
        "cn_name": "斐济",
        "two_letter_code": "FJ",
        "three_letter_code": "FJI",
        "number_code": 242,
        "lng": 178.065032,
        "lat": -17.713371
    },
    {
        "en_name": "Finland",
        "cn_name": "芬兰",
        "two_letter_code": "FI",
        "three_letter_code": "FIN",
        "number_code": 246,
        "lng": 25.748151,
        "lat": 61.92411
    },
    {
        "en_name": "France",
        "cn_name": "法国",
        "two_letter_code": "FR",
        "three_letter_code": "FRA",
        "number_code": 250,
        "lng": 2.213749,
        "lat": 46.227638
    },
    {
        "en_name": "French Polynesia",
        "cn_name": "法属波利尼西亚",
        "two_letter_code": "PF",
        "three_letter_code": "PYF",
        "number_code": 258,
        "lng": -149.407,
        "lat": -17.6797
    },
    {
        "en_name": "French Guiana",
        "cn_name": "法属圭亚那",
        "two_letter_code": "GF",
        "three_letter_code": "GUF",
        "number_code": 254,
        "lng": -53.125782,
        "lat": 3.933889
    },
    {
        "en_name": "French Southern Territories (the)",
        "cn_name": "法属南部领地",
        "two_letter_code": "TF",
        "three_letter_code": "ATF",
        "number_code": 260,
        "lng": 69.348557,
        "lat": -49.280366
    },
    {
        "en_name": "Gabon",
        "cn_name": "加蓬",
        "two_letter_code": "GA",
        "three_letter_code": "GAB",
        "number_code": 266,
        "lng": 11.609444,
        "lat": -0.803689
    },
    {
        "en_name": "Gambia (The)",
        "cn_name": "冈比亚",
        "two_letter_code": "GM",
        "three_letter_code": "GMB",
        "number_code": 270,
        "lng": -15.310139,
        "lat": 13.443182
    },
    {
        "en_name": "Georgia",
        "cn_name": "格鲁吉亚",
        "two_letter_code": "GE",
        "three_letter_code": "GEO",
        "number_code": 268,
        "lng": -82.9000751,
        "lat": 32.1656221
    },
    {
        "en_name": "Germany",
        "cn_name": "德国",
        "two_letter_code": "DE",
        "three_letter_code": "DEU",
        "number_code": 276,
        "lng": 10.451526,
        "lat": 51.165691
    },
    {
        "en_name": "Ghana",
        "cn_name": "加纳",
        "two_letter_code": "GH",
        "three_letter_code": "GHA",
        "number_code": 288,
        "lng": -1.023194,
        "lat": 7.946527
    },
    {
        "en_name": "Gibraltar",
        "cn_name": "直布罗陀",
        "two_letter_code": "GI",
        "three_letter_code": "GIB",
        "number_code": 292,
        "lng": -5.34537,
        "lat": 36.1377
    },
    {
        "en_name": "Greece",
        "cn_name": "希腊",
        "two_letter_code": "GR",
        "three_letter_code": "GRC",
        "number_code": 300,
        "lng": 21.824312,
        "lat": 39.074208
    },
    {
        "en_name": "Greenland",
        "cn_name": "格陵兰",
        "two_letter_code": "GL",
        "three_letter_code": "GRL",
        "number_code": 304,
        "lng": -42.604303,
        "lat": 71.706936
    },
    {
        "en_name": "Grenada",
        "cn_name": "格林纳达",
        "two_letter_code": "GD",
        "three_letter_code": "GRD",
        "number_code": 308,
        "lng": -61.6042,
        "lat": 12.2628
    },
    {
        "en_name": "Guam",
        "cn_name": "关岛",
        "two_letter_code": "GU",
        "three_letter_code": "GUM",
        "number_code": 316,
        "lng": 144.794,
        "lat": 13.4443
    },
    {
        "en_name": "Guatemala",
        "cn_name": "危地马拉",
        "two_letter_code": "GT",
        "three_letter_code": "GTM",
        "number_code": 320,
        "lng": -90.2307589999999,
        "lat": 15.783471
    },
    {
        "en_name": "Guinea",
        "cn_name": "几内亚",
        "two_letter_code": "GN",
        "three_letter_code": "GIN",
        "number_code": 324,
        "lng": -9.696645,
        "lat": 9.945587
    },
    {
        "en_name": "Guinea-Bissau",
        "cn_name": "几内亚比绍",
        "two_letter_code": "GW",
        "three_letter_code": "GNB",
        "number_code": 624,
        "lng": -15.180413,
        "lat": 11.803749
    },
    {
        "en_name": "Guyana",
        "cn_name": "圭亚那",
        "two_letter_code": "GY",
        "three_letter_code": "GUY",
        "number_code": 328,
        "lng": -58.93018,
        "lat": 4.860416
    },
    {
        "en_name": "Haiti",
        "cn_name": "海地",
        "two_letter_code": "HT",
        "three_letter_code": "HTI",
        "number_code": 332,
        "lng": -72.285215,
        "lat": 18.971187
    },
    {
        "en_name": "Honduras",
        "cn_name": "洪都拉斯",
        "two_letter_code": "HN",
        "three_letter_code": "HND",
        "number_code": 340,
        "lng": -86.241905,
        "lat": 15.199999
    },
    {
        "en_name": "Hong Kong",
        "cn_name": "中国香港",
        "two_letter_code": "HK",
        "three_letter_code": "HKG",
        "number_code": 344,
        "lng": 114.109,
        "lat": 22.3964
    },
    {
        "en_name": "Hungary",
        "cn_name": "匈牙利",
        "two_letter_code": "HU",
        "three_letter_code": "HUN",
        "number_code": 348,
        "lng": 19.503304,
        "lat": 47.162494
    },
    {
        "en_name": "Iceland",
        "cn_name": "冰岛",
        "two_letter_code": "IS",
        "three_letter_code": "ISL",
        "number_code": 352,
        "lng": -19.020835,
        "lat": 64.963051
    },
    {
        "en_name": "India",
        "cn_name": "印度",
        "two_letter_code": "IN",
        "three_letter_code": "IND",
        "number_code": 356,
        "lng": 78.96288,
        "lat": 20.593684
    },
    {
        "en_name": "Indonesia",
        "cn_name": "印度尼西亚",
        "two_letter_code": "ID",
        "three_letter_code": "IDN",
        "number_code": 360,
        "lng": 113.921327,
        "lat": -0.789275
    },
    {
        "en_name": "Iran (the Islamic Republic of)",
        "cn_name": "伊朗",
        "two_letter_code": "IR",
        "three_letter_code": "IRN",
        "number_code": 364,
        "lng": 53.688046,
        "lat": 32.427908
    },
    {
        "en_name": "Iraq",
        "cn_name": "伊拉克",
        "two_letter_code": "IQ",
        "three_letter_code": "IRQ",
        "number_code": 368,
        "lng": 43.679291,
        "lat": 33.223191
    },
    {
        "en_name": "Ireland",
        "cn_name": "爱尔兰",
        "two_letter_code": "IE",
        "three_letter_code": "IRL",
        "number_code": 372,
        "lng": -8.24389,
        "lat": 53.41291
    },
    {
        "en_name": "Israel",
        "cn_name": "以色列",
        "two_letter_code": "IL",
        "three_letter_code": "ISR",
        "number_code": 376,
        "lng": 34.851612,
        "lat": 31.046051
    },
    {
        "en_name": "Italy",
        "cn_name": "意大利",
        "two_letter_code": "IT",
        "three_letter_code": "ITA",
        "number_code": 380,
        "lng": 12.56738,
        "lat": 41.87194
    },
    {
        "en_name": "Côte d'Ivoire",
        "cn_name": "科特迪瓦",
        "two_letter_code": "CI",
        "three_letter_code": "CIV",
        "number_code": 384,
        "lng": -5.54707999999999,
        "lat": 7.539989
    },
    {
        "en_name": "Jamaica",
        "cn_name": "牙买加",
        "two_letter_code": "JM",
        "three_letter_code": "JAM",
        "number_code": 388,
        "lng": -77.297508,
        "lat": 18.109581
    },
    {
        "en_name": "Japan",
        "cn_name": "日本",
        "two_letter_code": "JP",
        "three_letter_code": "JPN",
        "number_code": 392,
        "lng": 138.252924,
        "lat": 36.204824
    },
    {
        "en_name": "Jordan",
        "cn_name": "约旦",
        "two_letter_code": "JO",
        "three_letter_code": "JOR",
        "number_code": 400,
        "lng": 36.238414,
        "lat": 30.585164
    },
    {
        "en_name": "Kazakhstan",
        "cn_name": "哈萨克斯坦",
        "two_letter_code": "KZ",
        "three_letter_code": "KAZ",
        "number_code": 398,
        "lng": 66.923684,
        "lat": 48.019573
    },
    {
        "en_name": "Kenya",
        "cn_name": "肯尼亚",
        "two_letter_code": "KE",
        "three_letter_code": "KEN",
        "number_code": 404,
        "lng": 37.906193,
        "lat": -0.023559
    },
    {
        "en_name": "Korea (the Republic of)",
        "cn_name": "韩国",
        "two_letter_code": "KR",
        "three_letter_code": "KOR",
        "number_code": 410,
        "lng": 127.767,
        "lat": 35.9078
    },
    {
        "en_name": "Kosovo",
        "cn_name": "科索沃",
        "two_letter_code": "XK",
        "three_letter_code": "",
        "number_code": "",
        "lng": 20.902977,
        "lat": 42.6026359
    },
    {
        "en_name": "Kuwait",
        "cn_name": "科威特",
        "two_letter_code": "KW",
        "three_letter_code": "KWT",
        "number_code": 414,
        "lng": 47.481766,
        "lat": 29.31166
    },
    {
        "en_name": "Kyrgyzstan",
        "cn_name": "吉尔吉斯斯坦",
        "two_letter_code": "KG",
        "three_letter_code": "KGZ",
        "number_code": 417,
        "lng": 74.766098,
        "lat": 41.20438
    },
    {
        "en_name": "Lao People's Democratic Republic (the)",
        "cn_name": "老挝",
        "two_letter_code": "LA",
        "three_letter_code": "LAO",
        "number_code": 418,
        "lng": 102.495496,
        "lat": 19.85627
    },
    {
        "en_name": "Latvia",
        "cn_name": "拉脱维亚",
        "two_letter_code": "LV",
        "three_letter_code": "LVA",
        "number_code": 428,
        "lng": 24.603189,
        "lat": 56.879635
    },
    {
        "en_name": "Lebanon",
        "cn_name": "黎巴嫩",
        "two_letter_code": "LB",
        "three_letter_code": "LBN",
        "number_code": 422,
        "lng": 35.862285,
        "lat": 33.854721
    },
    {
        "en_name": "Lesotho",
        "cn_name": "莱索托",
        "two_letter_code": "LS",
        "three_letter_code": "LSO",
        "number_code": 426,
        "lng": 28.233608,
        "lat": -29.609988
    },
    {
        "en_name": "Liberia",
        "cn_name": "利比里亚",
        "two_letter_code": "LR",
        "three_letter_code": "LBR",
        "number_code": 430,
        "lng": -9.429499,
        "lat": 6.428055
    },
    {
        "en_name": "Libyan Arab Jamahiriya (the)",
        "cn_name": "利比亚",
        "two_letter_code": "LY",
        "three_letter_code": "LBY",
        "number_code": 434,
        "lng": 17.228331,
        "lat": 26.3351
    },
    {
        "en_name": "Liechtenstein",
        "cn_name": "列支敦士登",
        "two_letter_code": "LI",
        "three_letter_code": "LIE",
        "number_code": 438,
        "lng": 9.56,
        "lat": 47.17
    },
    {
        "en_name": "Lithuania",
        "cn_name": "立陶宛",
        "two_letter_code": "LT",
        "three_letter_code": "LTU",
        "number_code": 440,
        "lng": 23.881275,
        "lat": 55.169438
    },
    {
        "en_name": "Luxembourg",
        "cn_name": "卢森堡",
        "two_letter_code": "LU",
        "three_letter_code": "LUX",
        "number_code": 442,
        "lng": 6.12958299999999,
        "lat": 49.815273
    },
    {
        "en_name": "Macao",
        "cn_name": "中国澳门",
        "two_letter_code": "MO",
        "three_letter_code": "MAC",
        "number_code": 446,
        "lng": 113.544,
        "lat": 22.1987
    },
    {
        "en_name": "Macedonia (the former Yugoslav Republic of)",
        "cn_name": "前南马其顿",
        "two_letter_code": "MK",
        "three_letter_code": "MKD",
        "number_code": 807,
        "lng": 21.745275,
        "lat": 41.608635
    },
    {
        "en_name": "Madagascar",
        "cn_name": "马达加斯加",
        "two_letter_code": "MG",
        "three_letter_code": "MDG",
        "number_code": 450,
        "lng": 46.869107,
        "lat": -18.766947
    },
    {
        "en_name": "Malawi",
        "cn_name": "马拉维",
        "two_letter_code": "MW",
        "three_letter_code": "MWI",
        "number_code": 454,
        "lng": 34.301525,
        "lat": -13.254308
    },
    {
        "en_name": "Malaysia",
        "cn_name": "马来西亚",
        "two_letter_code": "MY",
        "three_letter_code": "MYS",
        "number_code": 458,
        "lng": 101.975766,
        "lat": 4.210484
    },
    {
        "en_name": "Maldives",
        "cn_name": "马尔代夫",
        "two_letter_code": "MV",
        "three_letter_code": "MDV",
        "number_code": 462,
        "lng": 73.2207,
        "lat": 3.20278
    },
    {
        "en_name": "Mali",
        "cn_name": "马里",
        "two_letter_code": "ML",
        "three_letter_code": "MLI",
        "number_code": 466,
        "lng": -3.996166,
        "lat": 17.570692
    },
    {
        "en_name": "Malta",
        "cn_name": "马耳他",
        "two_letter_code": "MT",
        "three_letter_code": "MLT",
        "number_code": 470,
        "lng": 14.3754,
        "lat": 35.9375
    },
    {
        "en_name": "Northern Mariana Islands (the)",
        "cn_name": "北马里亚纳",
        "two_letter_code": "MP",
        "three_letter_code": "MNP",
        "number_code": 580,
        "lng": 145.385,
        "lat": 17.3308
    },
    {
        "en_name": "Martinique",
        "cn_name": "马提尼克",
        "two_letter_code": "MQ",
        "three_letter_code": "MTQ",
        "number_code": 474,
        "lng": -61.0242,
        "lat": 14.6415
    },
    {
        "en_name": "Mauritania",
        "cn_name": "毛里塔尼亚",
        "two_letter_code": "MR",
        "three_letter_code": "MRT",
        "number_code": 478,
        "lng": -10.940835,
        "lat": 21.00789
    },
    {
        "en_name": "Mauritius",
        "cn_name": "毛里求斯",
        "two_letter_code": "MU",
        "three_letter_code": "MUS",
        "number_code": 480,
        "lng": 57.5522,
        "lat": -20.3484
    },
    {
        "en_name": "Mexico",
        "cn_name": "墨西哥",
        "two_letter_code": "MX",
        "three_letter_code": "MEX",
        "number_code": 484,
        "lng": -102.552784,
        "lat": 23.634501
    },
    {
        "en_name": "Moldova (the Republic of)",
        "cn_name": "摩尔多瓦",
        "two_letter_code": "MD",
        "three_letter_code": "MDA",
        "number_code": 498,
        "lng": 28.369885,
        "lat": 47.411631
    },
    {
        "en_name": "Monaco",
        "cn_name": "摩纳哥",
        "two_letter_code": "MC",
        "three_letter_code": "MCO",
        "number_code": 492,
        "lng": 7.41284,
        "lat": 43.7503
    },
    {
        "en_name": "Mongolia",
        "cn_name": "蒙古",
        "two_letter_code": "MN",
        "three_letter_code": "MNG",
        "number_code": 496,
        "lng": 103.846656,
        "lat": 46.862496
    },
    {
        "en_name": "Montenegro",
        "cn_name": "黑山",
        "two_letter_code": "ME",
        "three_letter_code": "MNE",
        "number_code": 499,
        "lng": 19.37439,
        "lat": 42.708678
    },
    {
        "en_name": "Montserrat",
        "cn_name": "蒙特塞拉特",
        "two_letter_code": "MS",
        "three_letter_code": "MSR",
        "number_code": 500,
        "lng": -62.1874,
        "lat": 16.7425
    },
    {
        "en_name": "Morocco",
        "cn_name": "摩洛哥",
        "two_letter_code": "MA",
        "three_letter_code": "MAR",
        "number_code": 504,
        "lng": -7.09261999999999,
        "lat": 31.791702
    },
    {
        "en_name": "Mozambique",
        "cn_name": "莫桑比克",
        "two_letter_code": "MZ",
        "three_letter_code": "MOZ",
        "number_code": 508,
        "lng": 35.529562,
        "lat": -18.665695
    },
    {
        "en_name": "Myanmar",
        "cn_name": "缅甸",
        "two_letter_code": "MM",
        "three_letter_code": "MMR",
        "number_code": 104,
        "lng": 95.956223,
        "lat": 21.913965
    },
    {
        "en_name": "Namibia",
        "cn_name": "纳米比亚",
        "two_letter_code": "NA",
        "three_letter_code": "NAM",
        "number_code": 516,
        "lng": 18.49041,
        "lat": -22.95764
    },
    {
        "en_name": "Nauru",
        "cn_name": "瑙鲁",
        "two_letter_code": "NR",
        "three_letter_code": "NRU",
        "number_code": 520,
        "lng": 166.932,
        "lat": -0.522778
    },
    {
        "en_name": "Nepal",
        "cn_name": "尼泊尔",
        "two_letter_code": "NP",
        "three_letter_code": "NPL",
        "number_code": 524,
        "lng": 84.1240079999999,
        "lat": 28.394857
    },
    {
        "en_name": "Netherlands Antilles (the)",
        "cn_name": "荷属安的列斯",
        "two_letter_code": "AN",
        "three_letter_code": "ANT",
        "number_code": 530,
        "lng": -69.0601,
        "lat": 12.2261
    },
    {
        "en_name": "Netherlands (the)",
        "cn_name": "荷兰",
        "two_letter_code": "NL",
        "three_letter_code": "NLD",
        "number_code": 528,
        "lng": 5.29126599999999,
        "lat": 52.132633
    },
    {
        "en_name": "New Caledonia",
        "cn_name": "新喀里多尼亚",
        "two_letter_code": "NC",
        "three_letter_code": "NCL",
        "number_code": 540,
        "lng": 165.618042,
        "lat": -20.904305
    },
    {
        "en_name": "New Zealand",
        "cn_name": "新西兰",
        "two_letter_code": "NZ",
        "three_letter_code": "NZL",
        "number_code": 554,
        "lng": 174.885971,
        "lat": -40.900557
    },
    {
        "en_name": "Nicaragua",
        "cn_name": "尼加拉瓜",
        "two_letter_code": "NI",
        "three_letter_code": "NIC",
        "number_code": 558,
        "lng": -85.207229,
        "lat": 12.865416
    },
    {
        "en_name": "Niger (the)",
        "cn_name": "尼日尔",
        "two_letter_code": "NE",
        "three_letter_code": "NER",
        "number_code": 562,
        "lng": 8.081666,
        "lat": 17.607789
    },
    {
        "en_name": "Nigeria",
        "cn_name": "尼日利亚",
        "two_letter_code": "NG",
        "three_letter_code": "NGA",
        "number_code": 566,
        "lng": 8.675277,
        "lat": 9.081999
    },
    {
        "en_name": "Cyprus",
        "cn_name": "塞浦路斯",
        "two_letter_code": "CY",
        "three_letter_code": "CYP",
        "number_code": 196,
        "lng": 33.429859,
        "lat": 35.126413
    },
    {
        "en_name": "Korea (the Democratic People's Republic of)",
        "cn_name": "朝鲜",
        "two_letter_code": "KP",
        "three_letter_code": "PRK",
        "number_code": 408,
        "lng": 127.510093,
        "lat": 40.339852
    },
    {
        "en_name": "Norway",
        "cn_name": "挪威",
        "two_letter_code": "NO",
        "three_letter_code": "NOR",
        "number_code": 578,
        "lng": 8.46894599999999,
        "lat": 60.472024
    },
    {
        "en_name": "Oman",
        "cn_name": "阿曼",
        "two_letter_code": "OM",
        "three_letter_code": "OMN",
        "number_code": 512,
        "lng": 55.923255,
        "lat": 21.512583
    },
    {
        "en_name": "Pakistan",
        "cn_name": "巴基斯坦",
        "two_letter_code": "PK",
        "three_letter_code": "PAK",
        "number_code": 586,
        "lng": 69.3451159999999,
        "lat": 30.375321
    },
    {
        "en_name": "Panama",
        "cn_name": "巴拿马",
        "two_letter_code": "PA",
        "three_letter_code": "PAN",
        "number_code": 591,
        "lng": -80.782127,
        "lat": 8.537981
    },
    {
        "en_name": "Papua New Guinea",
        "cn_name": "巴布亚新几内亚",
        "two_letter_code": "PG",
        "three_letter_code": "PNG",
        "number_code": 598,
        "lng": 143.95555,
        "lat": -6.314993
    },
    {
        "en_name": "Paraguay",
        "cn_name": "巴拉圭",
        "two_letter_code": "PY",
        "three_letter_code": "PRY",
        "number_code": 600,
        "lng": -58.443832,
        "lat": -23.442503
    },
    {
        "en_name": "Peru",
        "cn_name": "秘鲁",
        "two_letter_code": "PE",
        "three_letter_code": "PER",
        "number_code": 604,
        "lng": -75.015152,
        "lat": -9.189967
    },
    {
        "en_name": "Philippines (the)",
        "cn_name": "菲律宾",
        "two_letter_code": "PH",
        "three_letter_code": "PHL",
        "number_code": 608,
        "lng": 121.774017,
        "lat": 12.879721
    },
    {
        "en_name": "Poland",
        "cn_name": "波兰",
        "two_letter_code": "PL",
        "three_letter_code": "POL",
        "number_code": 616,
        "lng": 19.145136,
        "lat": 51.919438
    },
    {
        "en_name": "Portugal",
        "cn_name": "葡萄牙",
        "two_letter_code": "PT",
        "three_letter_code": "PRT",
        "number_code": 620,
        "lng": -8.224454,
        "lat": 39.399872
    },
    {
        "en_name": "Puerto Rico",
        "cn_name": "波多黎各",
        "two_letter_code": "PR",
        "three_letter_code": "PRI",
        "number_code": 630,
        "lng": -66.590149,
        "lat": 18.220833
    },
    {
        "en_name": "Qatar",
        "cn_name": "卡塔尔",
        "two_letter_code": "QA",
        "three_letter_code": "QAT",
        "number_code": 634,
        "lng": 51.183884,
        "lat": 25.354826
    },
    {
        "en_name": "Congo",
        "cn_name": "刚果（布）",
        "two_letter_code": "CG",
        "three_letter_code": "COG",
        "number_code": 178,
        "lng": 15.827659,
        "lat": -0.228021
    },
    {
        "en_name": "Serbia",
        "cn_name": "塞尔维亚",
        "two_letter_code": "RS",
        "three_letter_code": "SRB",
        "number_code": 688,
        "lng": 21.005859,
        "lat": 44.016521
    },
    {
        "en_name": "Réunion",
        "cn_name": "留尼汪",
        "two_letter_code": "RE",
        "three_letter_code": "REU",
        "number_code": 638,
        "lng": 55.5364,
        "lat": -21.1151
    },
    {
        "en_name": "Romania",
        "cn_name": "罗马尼亚",
        "two_letter_code": "RO",
        "three_letter_code": "ROU",
        "number_code": 642,
        "lng": 24.96676,
        "lat": 45.943161
    },
    {
        "en_name": "Russian Federation (the)",
        "cn_name": "俄罗斯联邦",
        "two_letter_code": "RU",
        "three_letter_code": "RUS",
        "number_code": 643,
        "lng": 105.318756,
        "lat": 61.52401
    },
    {
        "en_name": "Rwanda",
        "cn_name": "卢旺达",
        "two_letter_code": "RW",
        "three_letter_code": "RWA",
        "number_code": 646,
        "lng": 29.873888,
        "lat": -1.940278
    },
    {
        "en_name": "Saint Lucia",
        "cn_name": "圣卢西亚",
        "two_letter_code": "LC",
        "three_letter_code": "LCA",
        "number_code": 662,
        "lng": -60.9789,
        "lat": 13.9094
    },
    {
        "en_name": "Saint Vincent and the Grenadines",
        "cn_name": "圣文森特和格林纳丁斯",
        "two_letter_code": "VC",
        "three_letter_code": "VCT",
        "number_code": 670,
        "lng": -61.2872,
        "lat": 12.9843
    },
    {
        "en_name": "American Samoa",
        "cn_name": "美属萨摩亚",
        "two_letter_code": "AS",
        "three_letter_code": "ASM",
        "number_code": 16,
        "lng": -170.132,
        "lat": -14.271
    },
    {
        "en_name": "Samoa",
        "cn_name": "萨摩亚",
        "two_letter_code": "WS",
        "three_letter_code": "WSM",
        "number_code": 882,
        "lng": -172.105,
        "lat": -13.759
    },
    {
        "en_name": "San Marino",
        "cn_name": "圣马力诺",
        "two_letter_code": "SM",
        "three_letter_code": "SMR",
        "number_code": 674,
        "lng": 12.4578,
        "lat": 43.9424
    },
    {
        "en_name": "Sao Tome and Principe",
        "cn_name": "圣多美和普林西比",
        "two_letter_code": "ST",
        "three_letter_code": "STP",
        "number_code": 678,
        "lng": 6.61308,
        "lat": 0.18636
    },
    {
        "en_name": "Saudi Arabia",
        "cn_name": "沙特阿拉伯",
        "two_letter_code": "SA",
        "three_letter_code": "SAU",
        "number_code": 682,
        "lng": 45.079162,
        "lat": 23.885942
    },
    {
        "en_name": "Senegal",
        "cn_name": "塞内加尔",
        "two_letter_code": "SN",
        "three_letter_code": "SEN",
        "number_code": 686,
        "lng": -14.452362,
        "lat": 14.497401
    },
    {
        "en_name": "Seychelles",
        "cn_name": "塞舌尔",
        "two_letter_code": "SC",
        "three_letter_code": "SYC",
        "number_code": 690,
        "lng": 55.492,
        "lat": -4.67957
    },
    {
        "en_name": "Sierra Leone",
        "cn_name": "塞拉利昂",
        "two_letter_code": "SL",
        "three_letter_code": "SLE",
        "number_code": 694,
        "lng": -11.779889,
        "lat": 8.460555
    },
    {
        "en_name": "Singapore",
        "cn_name": "新加坡",
        "two_letter_code": "SG",
        "three_letter_code": "SGP",
        "number_code": 702,
        "lng": 103.82,
        "lat": 1.35208
    },
    {
        "en_name": "Slovakia",
        "cn_name": "斯洛伐克",
        "two_letter_code": "SK",
        "three_letter_code": "SVK",
        "number_code": 703,
        "lng": 19.699024,
        "lat": 48.669026
    },
    {
        "en_name": "Slovenia",
        "cn_name": "斯洛文尼亚",
        "two_letter_code": "SI",
        "three_letter_code": "SVN",
        "number_code": 705,
        "lng": 14.995463,
        "lat": 46.151241
    },
    {
        "en_name": "Solomon Islands (the)",
        "cn_name": "所罗门群岛",
        "two_letter_code": "SB",
        "three_letter_code": "SLB",
        "number_code": 90,
        "lng": 160.156194,
        "lat": -9.64571
    },
    {
        "en_name": "Somalia",
        "cn_name": "索马里",
        "two_letter_code": "SO",
        "three_letter_code": "SOM",
        "number_code": 706,
        "lng": 46.199616,
        "lat": 5.152149
    },
    {
        "en_name": "South Africa",
        "cn_name": "南非",
        "two_letter_code": "ZA",
        "three_letter_code": "ZAF",
        "number_code": 710,
        "lng": 22.937506,
        "lat": -30.559482
    },
    {
        "en_name": "South Sudan",
        "cn_name": "南苏丹",
        "two_letter_code": "SS",
        "three_letter_code": "SSD",
        "number_code": "",
        "lng": 31.3069788,
        "lat": 6.8769919
    },
    {
        "en_name": "Spain",
        "cn_name": "西班牙",
        "two_letter_code": "ES",
        "three_letter_code": "ESP",
        "number_code": 724,
        "lng": -3.74922,
        "lat": 40.463667
    },
    {
        "en_name": "Sri Lanka",
        "cn_name": "斯里兰卡",
        "two_letter_code": "LK",
        "three_letter_code": "LKA",
        "number_code": 144,
        "lng": 80.7717969999999,
        "lat": 7.873054
    },
    {
        "en_name": "Sudan (the)",
        "cn_name": "苏丹",
        "two_letter_code": "SD",
        "three_letter_code": "SDN",
        "number_code": 736,
        "lng": 30.217636,
        "lat": 12.862807
    },
    {
        "en_name": "Suriname",
        "cn_name": "苏里南",
        "two_letter_code": "SR",
        "three_letter_code": "SUR",
        "number_code": 740,
        "lng": -56.027783,
        "lat": 3.919305
    },
    {
        "en_name": "Swaziland",
        "cn_name": "斯威士兰",
        "two_letter_code": "SZ",
        "three_letter_code": "SWZ",
        "number_code": 748,
        "lng": 31.465866,
        "lat": -26.522503
    },
    {
        "en_name": "Sweden",
        "cn_name": "瑞典",
        "two_letter_code": "SE",
        "three_letter_code": "SWE",
        "number_code": 752,
        "lng": 18.643501,
        "lat": 60.128161
    },
    {
        "en_name": "Switzerland",
        "cn_name": "瑞士",
        "two_letter_code": "CH",
        "three_letter_code": "CHE",
        "number_code": 756,
        "lng": 8.22751199999999,
        "lat": 46.818188
    },
    {
        "en_name": "Syrian Arab Republic (the)",
        "cn_name": "叙利亚",
        "two_letter_code": "SY",
        "three_letter_code": "SYR",
        "number_code": 760,
        "lng": 38.996815,
        "lat": 34.802075
    },
    {
        "en_name": "Taiwan (Province of China)",
        "cn_name": "中国台湾",
        "two_letter_code": "TW",
        "three_letter_code": "TWN",
        "number_code": 158,
        "lng": 120.961,
        "lat": 23.6978
    },
    {
        "en_name": "Tajikistan",
        "cn_name": "塔吉克斯坦",
        "two_letter_code": "TJ",
        "three_letter_code": "TJK",
        "number_code": 762,
        "lng": 71.276093,
        "lat": 38.861034
    },
    {
        "en_name": "Thailand",
        "cn_name": "泰国",
        "two_letter_code": "TH",
        "three_letter_code": "THA",
        "number_code": 764,
        "lng": 100.992541,
        "lat": 15.870032
    },
    {
        "en_name": "Bahamas (The)",
        "cn_name": "巴哈马",
        "two_letter_code": "BS",
        "three_letter_code": "BHS",
        "number_code": 44,
        "lng": -77.3962799999999,
        "lat": 25.03428
    },
    {
        "en_name": "Togo",
        "cn_name": "多哥",
        "two_letter_code": "TG",
        "three_letter_code": "TGO",
        "number_code": 768,
        "lng": 0.824782,
        "lat": 8.619543
    },
    {
        "en_name": "Tonga",
        "cn_name": "汤加",
        "two_letter_code": "TO",
        "three_letter_code": "TON",
        "number_code": 776,
        "lng": -175.198,
        "lat": -21.179
    },
    {
        "en_name": "Trinidad and Tobago",
        "cn_name": "特立尼达和多巴哥",
        "two_letter_code": "TT",
        "three_letter_code": "TTO",
        "number_code": 780,
        "lng": -61.2225,
        "lat": 10.6918
    },
    {
        "en_name": "Tunisia",
        "cn_name": "突尼斯",
        "two_letter_code": "TN",
        "three_letter_code": "TUN",
        "number_code": 788,
        "lng": 9.537499,
        "lat": 33.886917
    },
    {
        "en_name": "Turkey",
        "cn_name": "土耳其",
        "two_letter_code": "TR",
        "three_letter_code": "TUR",
        "number_code": 792,
        "lng": 35.243322,
        "lat": 38.963745
    },
    {
        "en_name": "Turkmenistan",
        "cn_name": "土库曼斯坦",
        "two_letter_code": "TM",
        "three_letter_code": "TKM",
        "number_code": 795,
        "lng": 59.556278,
        "lat": 38.969719
    },
    {
        "en_name": "Uganda",
        "cn_name": "乌干达",
        "two_letter_code": "UG",
        "three_letter_code": "UGA",
        "number_code": 800,
        "lng": 32.290275,
        "lat": 1.373333
    },
    {
        "en_name": "Ukraine",
        "cn_name": "乌克兰",
        "two_letter_code": "UA",
        "three_letter_code": "UKR",
        "number_code": 804,
        "lng": 31.16558,
        "lat": 48.379433
    },
    {
        "en_name": "United States (the)",
        "cn_name": "美国",
        "two_letter_code": "US",
        "three_letter_code": "USA",
        "number_code": 840,
        "lng": -95.7129,
        "lat": 37.0902
    },
    {
        "en_name": "United Arab Emirates (the)",
        "cn_name": "阿联酋",
        "two_letter_code": "AE",
        "three_letter_code": "ARE",
        "number_code": 784,
        "lng": 53.847818,
        "lat": 23.424076
    },
    {
        "en_name": "United Kingdom (the)",
        "cn_name": "英国",
        "two_letter_code": "GB",
        "three_letter_code": "GBR",
        "number_code": 826,
        "lng": -3.435973,
        "lat": 55.378051
    },
    {
        "en_name": "United Kingdom (the)",
        "cn_name": "英国",
        "two_letter_code": "UK",
        "three_letter_code": "GBR",
        "number_code": 826,
        "lng": -3.435973,
        "lat": 55.378051
    },
    {
        "en_name": "Tanzania,United Republic of",
        "cn_name": "坦桑尼亚",
        "two_letter_code": "TZ",
        "three_letter_code": "TZA",
        "number_code": 834,
        "lng": 34.888822,
        "lat": -6.369028
    },
    {
        "en_name": "Uruguay",
        "cn_name": "乌拉圭",
        "two_letter_code": "UY",
        "three_letter_code": "URY",
        "number_code": 858,
        "lng": -55.765835,
        "lat": -32.522779
    },
    {
        "en_name": "Uzbekistan",
        "cn_name": "乌兹别克斯坦",
        "two_letter_code": "UZ",
        "three_letter_code": "UZB",
        "number_code": 860,
        "lng": 64.585262,
        "lat": 41.377491
    },
    {
        "en_name": "Vanuatu",
        "cn_name": "瓦努阿图",
        "two_letter_code": "VU",
        "three_letter_code": "VUT",
        "number_code": 548,
        "lng": 166.959158,
        "lat": -15.376706
    },
    {
        "en_name": "Venezuela",
        "cn_name": "委内瑞拉",
        "two_letter_code": "VE",
        "three_letter_code": "VEN",
        "number_code": 862,
        "lng": -66.58973,
        "lat": 6.42375
    },
    {
        "en_name": "Viet Nam",
        "cn_name": "越南",
        "two_letter_code": "VN",
        "three_letter_code": "VNM",
        "number_code": 704,
        "lng": 108.277199,
        "lat": 14.058324
    },
    {
        "en_name": "Palestinian Territory (the Occupied)",
        "cn_name": "巴勒斯坦",
        "two_letter_code": "PS",
        "three_letter_code": "PSE",
        "number_code": 275,
        "lng": 35.2332,
        "lat": 31.9522
    },
    {
        "en_name": "Western Sahara",
        "cn_name": "西撒哈拉",
        "two_letter_code": "EH",
        "three_letter_code": "ESH",
        "number_code": 732,
        "lng": -12.885834,
        "lat": 24.215527
    },
    {
        "en_name": "Yemen",
        "cn_name": "也门",
        "two_letter_code": "YE",
        "three_letter_code": "YEM",
        "number_code": 887,
        "lng": 48.516388,
        "lat": 15.552727
    },
    {
        "en_name": "Yugoslavia",
        "cn_name": "南斯拉夫",
        "two_letter_code": "YU",
        "three_letter_code": "YUG",
        "number_code": 891,
        "lng": 121.02,
        "lat": 14.48
    },
    {
        "en_name": "Zambia",
        "cn_name": "赞比亚",
        "two_letter_code": "ZM",
        "three_letter_code": "ZMB",
        "number_code": 894,
        "lng": 27.849332,
        "lat": -13.133897
    },
    {
        "en_name": "Zimbabwe",
        "cn_name": "津巴布韦",
        "two_letter_code": "ZW",
        "three_letter_code": "ZWE",
        "number_code": 716,
        "lng": 29.154857,
        "lat": -19.015438
    },
    {
        "en_name": "Antarctica",
        "cn_name": "南极洲",
        "two_letter_code": "AQ",
        "three_letter_code": "ATA",
        "number_code": 10,
        "lng": -0.071389,
        "lat": -75.251
    },
    {
        "en_name": "Antigua and Barbuda",
        "cn_name": "安提瓜和巴布达",
        "two_letter_code": "AG",
        "three_letter_code": "ATG",
        "number_code": 28,
        "lng": -61.7964,
        "lat": 17.0608
    },
    {
        "en_name": "Aruba",
        "cn_name": "阿鲁巴",
        "two_letter_code": "AW",
        "three_letter_code": "ABW",
        "number_code": 533,
        "lng": -69.9683,
        "lat": 12.5211
    },
    {
        "en_name": "Bouvet Island",
        "cn_name": "布维岛",
        "two_letter_code": "BV",
        "three_letter_code": "BVT",
        "number_code": 74,
        "lng": 3.41319,
        "lat": 54.4232
    },
    {
        "en_name": "British Indian Ocean Territory (the)",
        "cn_name": "英属印度洋领地",
        "two_letter_code": "IO",
        "three_letter_code": "IOT",
        "number_code": 86,
        "lng": 71.8765,
        "lat": -6.34319
    },
    {
        "en_name": "Cape Verde",
        "cn_name": "佛得角",
        "two_letter_code": "CV",
        "three_letter_code": "CPV",
        "number_code": 132,
        "lng": -24.0132,
        "lat": -24.0132
    },
    {
        "en_name": "Christmas Island",
        "cn_name": "圣诞岛",
        "two_letter_code": "CX",
        "three_letter_code": "CXR",
        "number_code": 162,
        "lng": 105.69,
        "lat": -10.4475
    },
    {
        "en_name": "Comoros",
        "cn_name": "科摩罗",
        "two_letter_code": "KM",
        "three_letter_code": "COM",
        "number_code": 174,
        "lng": 43.8722,
        "lat": -11.875
    },
    {
        "en_name": "Faroe Islands (the)",
        "cn_name": "法罗群岛",
        "two_letter_code": "FO",
        "three_letter_code": "FRO",
        "number_code": 234,
        "lng": -6.91181,
        "lat": 61.8926
    },
    {
        "en_name": "Guadeloupe",
        "cn_name": "瓜德罗普",
        "two_letter_code": "GP",
        "three_letter_code": "GLP",
        "number_code": 312,
        "lng": -62.0676,
        "lat": 16.996
    },
    {
        "en_name": "Guernsey",
        "cn_name": "格恩西岛",
        "two_letter_code": "GG",
        "three_letter_code": "GGY",
        "number_code": 831,
        "lng": -2.58528,
        "lat": 49.4657
    },
    {
        "en_name": "Holy See (the) [Vatican City State]",
        "cn_name": "梵蒂冈",
        "two_letter_code": "VA",
        "three_letter_code": "VAT",
        "number_code": 336,
        "lng": 12.4534,
        "lat": 41.9029
    },
    {
        "en_name": "Isle of Man",
        "cn_name": "英国属地曼岛",
        "two_letter_code": "IM",
        "three_letter_code": "IMN",
        "number_code": 833,
        "lng": -4.54806,
        "lat": 54.2361
    },
    {
        "en_name": "Jersey",
        "cn_name": "泽西岛",
        "two_letter_code": "JE",
        "three_letter_code": "JEY",
        "number_code": 832,
        "lng": -2.13125,
        "lat": 49.2144
    },
    {
        "en_name": "Kiribati",
        "cn_name": "基里巴斯",
        "two_letter_code": "KI",
        "three_letter_code": "KIR",
        "number_code": 296,
        "lng": -168.734,
        "lat": -3.37042
    },
    {
        "en_name": "Marshall Islands (the)",
        "cn_name": "马绍尔群岛",
        "two_letter_code": "MH",
        "three_letter_code": "MHL",
        "number_code": 584,
        "lng": 171.184,
        "lat": 7.13147
    },
    {
        "en_name": "Mayotte",
        "cn_name": "马约特",
        "two_letter_code": "YT",
        "three_letter_code": "MYT",
        "number_code": 175,
        "lng": 45.1662,
        "lat": -12.8275
    },
    {
        "en_name": "Niue",
        "cn_name": "纽埃",
        "two_letter_code": "NU",
        "three_letter_code": "NIU",
        "number_code": 570,
        "lng": -169.867,
        "lat": -19.0544
    },
    {
        "en_name": "Norfolk Island",
        "cn_name": "诺福克岛",
        "two_letter_code": "NF",
        "three_letter_code": "NFK",
        "number_code": 574,
        "lng": 167.955,
        "lat": -29.0408
    },
    {
        "en_name": "Palau",
        "cn_name": "帕劳",
        "two_letter_code": "PW",
        "three_letter_code": "PLW",
        "number_code": 585,
        "lng": 134.583,
        "lat": 7.51498
    },
    {
        "en_name": "Saint Helena",
        "cn_name": "圣赫勒拿",
        "two_letter_code": "SH",
        "three_letter_code": "SHN",
        "number_code": 654,
        "lng": -10.0307,
        "lat": -24.1435
    },
    {
        "en_name": "Saint Kitts and Nevis",
        "cn_name": "圣基茨和尼维斯",
        "two_letter_code": "KN",
        "three_letter_code": "KNA",
        "number_code": 659,
        "lng": -62.783,
        "lat": 17.3578
    },
    {
        "en_name": "Tokelau",
        "cn_name": "托克劳",
        "two_letter_code": "TK",
        "three_letter_code": "TKL",
        "number_code": 772,
        "lng": -171.856,
        "lat": -8.96736
    },
    {
        "en_name": "Turks and Caicos Islands (the)",
        "cn_name": "特克斯和凯科斯群岛",
        "two_letter_code": "TC",
        "three_letter_code": "TCA",
        "number_code": 796,
        "lng": -71.7979,
        "lat": 21.694
    },
    {
        "en_name": "Tuvalu",
        "cn_name": "图瓦卢",
        "two_letter_code": "TV",
        "three_letter_code": "TUV",
        "number_code": 798,
        "lng": 177.649,
        "lat": -7.10954
    },
    {
        "en_name": "Virgin Islands (British)",
        "cn_name": "英属维尔京群岛",
        "two_letter_code": "VG",
        "three_letter_code": "VGB",
        "number_code": 92,
        "lng": -64.64,
        "lat": 18.4207
    },
    {
        "en_name": "Virgin Islands (U.S.)",
        "cn_name": "美属维尔京群岛",
        "two_letter_code": "VI",
        "three_letter_code": "VIR",
        "number_code": 850,
        "lng": -64.8963,
        "lat": 18.3358
    },
    {
        "en_name": "Cocos (Keeling) Islands (the)",
        "cn_name": "科科斯（基林）群岛",
        "two_letter_code": "CC",
        "three_letter_code": "CCK",
        "number_code": 166,
        "lng": 96.871,
        "lat": -12.1642
    },
    {
        "en_name": "Heard Island and McDonald Islands",
        "cn_name": "赫德岛和麦克唐纳岛",
        "two_letter_code": "HM",
        "three_letter_code": "HMD",
        "number_code": 334,
        "lng": 73.5042,
        "lat": -53.0818
    },
    {
        "en_name": "Micronesia (the Federated States of)",
        "cn_name": "密克罗尼西亚联邦",
        "two_letter_code": "FM",
        "three_letter_code": "FSM",
        "number_code": 583,
        "lng": 150.551,
        "lat": 7.42555
    },
    {
        "en_name": "Pitcairn",
        "cn_name": "皮特凯恩",
        "two_letter_code": "PN",
        "three_letter_code": "PCN",
        "number_code": 612,
        "lng": -127.439,
        "lat": -24.7036
    },
    {
        "en_name": "Saint Pierre and Miquelon",
        "cn_name": "圣皮埃尔和密克隆",
        "two_letter_code": "PM",
        "three_letter_code": "SPM",
        "number_code": 666,
        "lng": -56.2711,
        "lat": 46.9419
    },
    {
        "en_name": "South Georgia and the South Sandwich Islands",
        "cn_name": "南乔治亚岛和南桑德韦奇岛",
        "two_letter_code": "GS",
        "three_letter_code": "SGS",
        "number_code": 239,
        "lng": -36.5879,
        "lat": -54.4296
    },
    {
        "en_name": "Svalbard and Jan Mayen",
        "cn_name": "斯瓦尔巴岛和扬马延岛",
        "two_letter_code": "SJ",
        "three_letter_code": "SJM",
        "number_code": 744,
        "lng": 23.6703,
        "lat": 77.5536
    },
    {
        "en_name": "Wallis and Futuna",
        "cn_name": "瓦利斯和富图纳",
        "two_letter_code": "WF",
        "three_letter_code": "WLF",
        "number_code": 876,
        "lng": -177.156,
        "lat": -13.7688
    }
]